import CustomStore from 'devextreme/data/custom_store';
import { Http } from '@angular/http';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid } from './../app.config';
import { Equipe } from './equipe.model';
import { NTECH_API } from '../app.api';
import { EmpresaService } from './../empresa/empresa.service';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'ntc-equipe',
  templateUrl: './equipe.component.html',
  styleUrls: ['./equipe.component.css']
})
export class EquipeComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  loadingVisible = false;
  listaEquipe: CustomStore;
  listaEmpresa = null;
  listaForm = {Id: 'listaEmpresa', status: false};
  alturaGrid = null;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  colunasGridEquipe = [];

  editOptionsGridEquipe = {
    mode: GridConfig.gridMode,
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Equipe',
      showTitle: true
    }
  };

  constructor(
    @Inject(Http) http: Http,
    private empresaService: EmpresaService
  ) {

    // carrega a lista de Empresas
    this.empresaService.getEmpresas()
      .subscribe(empresas => {
        this.listaEmpresa = empresas;
        this.verificarListasCarregadas('listaEmpresa');
      },
      error => {
        this.verificarListasCarregadas('listaEmpresa');
      }
    );

    this.listaEquipe = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/equipes/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/equipes/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/equipes/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/equipes/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  verificarListasCarregadas(nomeLista: string): boolean {

    // altera o status da lista informada para true
    if (nomeLista !== '') {
      this.listaForm.status = true;
    }

    // verifica os status das listas para montar o form  e retirar o backdrop (loading)
    if (this.listaForm.status === true) {

      this.colunasGridEquipe = [
        {
          dataField: 'Id',
          dataType: 'string',
          caption: 'ID',
          editorOptions: { disabled: true }
        },
        {
          dataField: 'DescricaoEquipe',
          dataType: 'string',
          caption: 'Descrição Equipe',
          validationRules: [{
            type: 'required',
            message: 'Descrição Equipe é obrigatório.'
          }]
        },
        {
          dataField: 'IdPessoa',
          caption: 'Empresa',
          lookup: {
              dataSource: this.listaEmpresa,
              displayExpr: 'Nome',
              valueExpr: 'Id'
          },
          validationRules: [{
            type: 'required',
            message: 'Empresa é obrigatório.'
          }]
        }
      ];

      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/equipe/equipe.component.ts